import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import Messages, {
    messagesLevels,
    messagesActions as MessagesActions,
} from 'yoda-site-components/lib/components/Messages';
import filter from 'lodash/filter';
import forEach from 'lodash/forEach';
import debounce from 'lodash/debounce';
import get from 'lodash/get';
import find from 'lodash/find';
import isEmpty from 'lodash/isEmpty';
import List from 'yoda-core-components/lib/components/List/List';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import Warning from 'yoda-core-components/lib/assets/svg/Warning.svg';
import ImgNotAvailable from 'yoda-core-components/lib/assets/svg/ImgNotAvailable.svg';
import {
    selectDeviceName,
    selectFeatureFlags,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import { bundleColorSwatchHover } from 'yoda-site-components/lib/actions/ColorSwatchesAction';
import DataSizeChart from 'yoda-site-components/lib/components/DataSizeChart/DataSizeChart';
import KnowledgeAssistance from 'yoda-site-components/lib/components/KnowledgeAssistance/KnowledgeAssistance';
import SelectDropdown from 'yoda-site-components/lib/components/SelectDropdown/SelectDropdown';
import ProductModule from 'yoda-site-components/lib/selectors/ProductOptionsSelector';
import ProductOptionPills from 'yoda-site-components/lib/components/ProductOptionPills/ProductOptionPills';
import { productOptionsBundleOnChangeAction } from 'yoda-site-components/lib/actions/ProductOptionsAction';
import handleMobileColorSelectionBehaviour from 'yoda-site-components/lib/helpers/Utils/mobileColorSelectionHelper';
import * as styles from './BundleProductOptions.css';
import { formErrorAnalytics } from '../../../actions/AnalyticsAction';
import getItemOfferingAction from '../../../actions/BundleItemOfferingAction';
import { productOptionsBundleOnLoadAction } from '../../../actions/BundleProductOptionsOnLoadAction';
import ProductConstants from '../../../helpers/ProductConstants';
import { getStoreID } from '../../../selectors/Bundle/BundleCommonSelector';
import { getProductOptionsSelection } from '../../../selectors/Bundle/BundleProductOptionsSelector';
import getBundleInventoryStatus from '../../../selectors/Bundle/BundleInventorySelector';
import { ADD_TO_CART_MESSAGES_ID } from '../BundleAddToCart/BundleAddToCart.config';

const cx = classNames.bind(styles);
const swatchWidth = 50;
let swatchesMaxLn = '';
const productType = ProductConstants.REGULAR;
const DEFAULT_COLOR_MSG = 'Select a Color';

export class ProductOptions extends Component {
    static defaultProps = {
        actions: {},
        productOptions: {
            optionsSelected: [],
            dimensions: [],
            filteredItems: [],
        },
        productDetails: {},
        deviceType: {},
        messages: [],
        query: {},
        messagesTexts: {},
        changeOption: {},
        itemOfferings: {},
        deviceName: 'desktop',
        storeID: '',
        isEveryDimensionSelected: false,
        featureFlags: {},
        productPillsLimit: 9,
        bundleProductOptionsSelectedOnLoad: [],
        getBundleInventory: {},
    };

    static propTypes = {
        actions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productOptions: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        productDetails: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
        deviceType: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        changeOption: PropTypes.oneOfType([PropTypes.object, PropTypes.bool]),
        messages: PropTypes.oneOfType([PropTypes.array]),
        messagesTexts: PropTypes.oneOfType([PropTypes.object]),
        storeID: PropTypes.number,
        deviceName: PropTypes.string,
        isEveryDimensionSelected: PropTypes.bool,
        featureFlags: PropTypes.object,
        productPillsLimit: PropTypes.number,
        bundleProductOptionsSelectedOnLoad: PropTypes.oneOfType([
            PropTypes.object,
            PropTypes.array,
        ]),
        query: PropTypes.object,
        getBundleInventory: PropTypes.object,
    };

    /* istanbul ignore next */
    constructor(props) {
        super(props);
        this.showMoreLessOnClick = this.showMoreLessOnClick.bind(this);
        swatchesMaxLn = this.getMaxSwatchLengthForDevice(props.deviceName);
        this.onColorSwatchEnter = debounce(this.onColorSwatchEnter, 100);
        this.onColorSwatchLeave = debounce(this.onColorSwatchLeave, 100);
        this.state = {
            displaySize: true,
            displayTopSizeChart: false,
            viewMoreSwatches: false,
            isOOSAnalyticComplete: false,
            hoveredSwatch: null,
        };
        this.displayMoreOrLess = false;
        this.selectedColorAvailable = false;
    }

    componentDidMount() {
        const {
            productOptions,
            productDetails: { sizeGuide = {} },
            featureFlags: { disableDataSizeChart = false },
        } = this.props;
        const isSizeGuideAvailable = !isEmpty(Object.keys(sizeGuide)) && !disableDataSizeChart;
        if (productOptions.pricingURL.itemOfferingCall && productOptions.pricingURL.URL) {
            this.getItemOffering(this.props);
        }
        if ((!isSizeGuideAvailable && !disableDataSizeChart) || disableDataSizeChart) {
            this.setState({ displayTopSizeChart: true });
        } else if (isSizeGuideAvailable && !disableDataSizeChart) {
            this.setState({ displayTopSizeChart: true });
        }
    }

    componentWillReceiveProps(nextProps) {
        const { productOptions, isEveryDimensionSelected, actions } = this.props;
        /* istanbul ignore next */
        if (
            nextProps.productOptions.pricingURL.itemOfferingCall &&
            nextProps.productOptions.pricingURL.URL !== productOptions.pricingURL.URL
        ) {
            this.getItemOffering(nextProps);
        }
        /* istanbul ignore next */
        if (
            isEveryDimensionSelected !== nextProps.isEveryDimensionSelected &&
            nextProps.isEveryDimensionSelected
        ) {
            actions.removeAllMessages({
                section: ADD_TO_CART_MESSAGES_ID,
                sourceMiniPDP: false,
            });
        }
        const itemOfferingCall = get(productOptions, 'pricingURL.itemOfferingCall', false);
        const nextItemOfferingCall = get(
            nextProps.productOptions,
            'pricingURL.itemOfferingCall',
            false
        );
        if (itemOfferingCall !== nextItemOfferingCall && nextItemOfferingCall) {
            this.setSelectedProductOptionsOnLoad();
        }
    }

    onProductOptionsChange(option, productId, dimensionName) {
        const {
            changeOption,
            productOptions: { optionsSelected },
        } = this.props;
        /* istanbul ignore next */
        const optionDetails = filter(changeOption, (data) => data.productId !== productId);
        const changeObj = {
            option,
            productId,
            dimensionName,
        };
        const preSelectedOptions = filter(
            optionsSelected,
            (selectedOption) => selectedOption.dimensionName !== dimensionName
        ).map((obj) => ({
            option: obj.option,
            productId,
            dimensionName: obj.dimensionName,
        }));
        this.props.actions.productOptionsBundleOnChangeAction([
            ...optionDetails,
            changeObj,
            ...preSelectedOptions,
        ]);
    }

    onChangeHandler(dimension, dataItem, value, colorUnavailable, e) {
        if (value === dimension.name) {
            return null;
        }

        const {
            productDetails: { id },
            messagesTexts: { ProductOptionsMessages },
            featureFlags: { enableColorCarousel = true },
            deviceType: { isMobile },
        } = this.props;

        this.props.actions.removeAllMessages({
            section: `${dimension.id}_MESSAGES_SECTION_${id}`,
            sourceMiniPDP: false,
        });
        /* istanbul ignore next */
        dataItem =
            dataItem ||
            dimension.options.filter(
                ({ value: optionValue }) => `${optionValue}` === `${value}`
            )[0] ||
            {};
        const messageId = `${dimension.id}MessageId`;
        this.props.actions.removeMessage({ section: id, id: messageId });
        this.props.actions.removeAllMessages({
            section: `OOS_${id}`,
            sourceMiniPDP: false,
        });
        /* istanbul ignore next */
        if (typeof dataItem.availableInStock !== 'undefined' && !dataItem.availableInStock) {
            const isDefaultDeimensionSelected =
                this.getDefaultValueSelected(dimension.id) === dataItem.value;
            this.props.actions.addMessage({
                section: `OOS_${id}`,
                message: {
                    id: `OOS_MessageId_${id}`,
                    title: 'Out of stock',
                    type: 'warning',
                },
            });
            /**
             * MPDPYODA-4379
             * When there is single dimension and it is auto selected by default , in this case when item is alreday showing out of stock message then do not triiger the OOS analytics call.
             * example: Whern we selects OOS Size and we get default single color selected which is also out of stock.
             */
            if (
                !isDefaultDeimensionSelected ||
                (isDefaultDeimensionSelected && isEmpty(this.props.messages[`OOS_${id}`]))
            ) {
                this.props.actions.formErrorAnalytics([
                    { errorDescription: ProductOptionsMessages.oosMessage.toLowerCase() },
                ]);
            }
        }
        this.onProductOptionsChange(value, id, dimension.name);
        this.selectedColorAvailable = colorUnavailable;
        if (dimension.id === 'COLOR' && isMobile && enableColorCarousel) {
            const colorList = e?.target?.closest && e?.target?.closest('#productOptionsColorList');
            handleMobileColorSelectionBehaviour(value, colorList, null, 0, colorUnavailable);
        }
        return null;
    }

    /* Action to store the list of SKUs selected for a bundle child item.
    Will trigger the action only when all the SKUs are selected from a child item */
    setSelectedProductOptionsOnLoad = () => {
        const {
            bundleProductOptionsSelectedOnLoad,
            productDetails,
            productOptions,
            actions,
        } = this.props;
        const optionsSelected = get(productOptions, 'optionsSelected', {});
        /* istanbul ignore else */
        if (!isEmpty(optionsSelected) && Array.isArray(bundleProductOptionsSelectedOnLoad)) {
            const detailsAvailable = find(bundleProductOptionsSelectedOnLoad, {
                productId: productDetails.id,
            });
            /* istanbul ignore else */
            if (isEmpty(detailsAvailable)) {
                const selectedDimensions = optionsSelected.map((option) => {
                    return {
                        option: option.option,
                        dimensionName: option.dimensionName,
                    };
                });
                const details = {
                    productId: productDetails.id,
                    selectedDimensions,
                };
                const payload = bundleProductOptionsSelectedOnLoad;
                payload.push(details);
                actions.productOptionsBundleOnLoadAction(payload);
            }
        }
    };

    onColorSwatchEnter = (item) => {
        this.setState({
            hoveredSwatch: item,
        });

        this.props.actions.bundleColorSwatchHover({
            image: item.productImage,
            ppId: get(this.props, 'productDetails.id'),
        });
    };
    /* istanbul ignore next */

    onColorSwatchLeave = () => {
        this.setState({
            hoveredSwatch: null,
        });

        // reset color swatches hover.
        this.props.actions.bundleColorSwatchHover({});
    };

    getItemOffering(props) {
        const { productDetails, productOptions } = props;
        const { storeID } = this.props;
        const params = {};
        /* istanbul ignore next */
        if (storeID) {
            params.stores = storeID;
        }
        const warehouseClass = get(productOptions, 'selectedProductLot[0].warehouseClassCode', '');
        props.actions.getItemOfferingAction({
            url: productOptions.pricingURL.URL,
            params,
            id: productDetails.id,
            warehouseClass,
        });
    }

    getDefaultValueSelected(type) {
        const {
            productOptions: { optionsSelected },
        } = this.props;
        const optionValue =
            optionsSelected &&
            optionsSelected.length &&
            optionsSelected.filter((optionSelected) => optionSelected.type === type);
        return optionValue && optionValue[0] ? optionValue[0].option : '';
    }

    getMaxSwatchLengthForMobile() {
        // default max swathces for mobile.
        let mobileMaxSwatches = 7;
        /* istanbul ignore next */
        if (typeof window !== 'undefined' && window.innerWidth) {
            mobileMaxSwatches = Math.floor(window.innerWidth / swatchWidth);
        }
        return mobileMaxSwatches;
    }

    getMaxSwatchLengthForDevice(deviceName) {
        let swatchCount;
        switch (deviceName) {
            case 'tablet':
                swatchCount = 17;
                break;
            case 'mobile':
                swatchCount = this.getMaxSwatchLengthForMobile();
                break;
            default:
                swatchCount = 19;
        }
        return swatchCount;
    }

    showMoreLessOnClick(e) {
        e.preventDefault();
        this.setState({
            viewMoreSwatches: !this.state.viewMoreSwatches,
        });
    }

    replaceColorInDimensions(dimensions) {
        const colorDimensions = [];
        const dimensionsWithoutColor = [];

        forEach(dimensions, (item) => {
            if (item.id === 'COLOR') {
                colorDimensions.unshift(item);
            } else if (item.id === 'LENGTH') {
                colorDimensions.push(item);
            } else {
                dimensionsWithoutColor.push(item);
            }
        });

        return [...colorDimensions, ...dimensionsWithoutColor];
    }

    isSizeDimension(dimension) {
        return dimension.id === 'SIZE' || dimension.id === 'WAIST' || dimension.id === 'CHEST';
    }

    /* Renders a single color swatch */
    renderProductOptionsColorItem(dimension, dataItem, index) {
        const {
            featureFlags: { enableColorCarousel = true },
            deviceType: { isMobile },
        } = this.props;
        let colorItem = '';
        const shouldRenderSingleRow = enableColorCarousel && isMobile;
        // reduce swatchesMaxLn by 1 to accomodate "more/less" link.
        const actualSwatchesMaxLen = this.displayMoreOrLess ? swatchesMaxLn - 1 : swatchesMaxLn;
        const toggleOptionsColorShow =
            !this.state.viewMoreSwatches && index > actualSwatchesMaxLen && !shouldRenderSingleRow
                ? 'hiddenTrue'
                : null;
        const numOfHiddenSwatches = dimension.options.length - swatchesMaxLn;
        const checkSelectedValue = this.getDefaultValueSelected('COLOR') === dataItem.value;
        const isColorHovered =
            dataItem.value === get(this.state, 'hoveredSwatch.value') && !checkSelectedValue;
        const colorUnavailable = !dataItem.availableInStock;
        let colorUnavailableHTML = null;
        const missingSwatch = dataItem.image === undefined;
        if (this.selectedColorAvailable !== colorUnavailable && checkSelectedValue) {
            this.selectedColorAvailable = colorUnavailable;
            this.onChangeHandler(dimension, dataItem, dataItem.value, colorUnavailable);
        }
        let colorSelected;
        if (checkSelectedValue && colorUnavailable) {
            colorSelected = 'colorOOSSelected';
        } else if (checkSelectedValue && !colorUnavailable) {
            colorSelected = 'colorSelected';
        } else if (colorUnavailable) {
            colorSelected = 'colorOOS';
        }
        const colorOOSbgStyle =
            checkSelectedValue && colorUnavailable
                ? dt(['bg-light-white', 'rounded-full', 'aspect-square'])
                : '';
        const colorMarginStyle = !toggleOptionsColorShow ? dt(['mr-2', 'mb-2']) : '';
        const bundleOOSStyle =
            colorUnavailable && !toggleOptionsColorShow
                ? dt([
                      'relative',
                      'rounded-full',
                      'before:bg-light-white',
                      'before:md:w-11',
                      'before:md:h-11',
                      'before:smOnly:w-12',
                      'before:smOnly:h-12',
                      'before:rounded-full',
                      'before:absolute',
                      'before:top-0.5',
                      'before:left-0.5',
                  ])
                : '';
        if (dataItem.family !== 'More or Less Option') {
            if (colorUnavailable) {
                colorUnavailableHTML = (
                    <span className={cx('colorUnavailable')}>
                        <span className={cx('strike')} />
                    </span>
                );
            }
            colorItem = (
                <div
                    className={`${cx({
                        bundleColorOOS: colorUnavailable,
                        bundleColorOOSSelected: checkSelectedValue && colorUnavailable,
                    })} ${dt([colorMarginStyle, bundleOOSStyle, colorOOSbgStyle])}`}
                    style={{ display: toggleOptionsColorShow === 'hiddenTrue' ? 'none' : 'block' }}
                >
                    <button
                        className={`${cx('optionColor', toggleOptionsColorShow, colorSelected, {
                            colorHovered: isColorHovered,
                        })} ${dt([
                            'smOnly:!w-[52px]',
                            'smOnly:!h-[52px]',
                            'md:!w-12',
                            'md:!h-12',
                            '!rounded-full',
                            'p-0.5',
                        ])}`}
                        onClick={(e) =>
                            this.onChangeHandler(
                                dimension,
                                dataItem,
                                dataItem.value,
                                colorUnavailable,
                                e
                            )
                        } //eslint-disable-line
                        data-tip
                        data-for={dataItem.value}
                        onMouseEnter={
                            this.props.deviceType.isDesktop &&
                            this.onColorSwatchEnter.bind(this, dataItem, colorUnavailable)
                        }
                        style={{
                            background: !missingSwatch
                                ? `url(${dataItem.image.url}?wid=35&hei=35&resmode=sharp2)`
                                : '',
                        }}
                    >
                        {colorUnavailableHTML}
                        {missingSwatch ? (
                            <Icon
                                iconType="svg"
                                pathClassName={cx('iconPath')}
                                className={cx('svg-icon')}
                                width="35"
                                height="35"
                                viewBox="0 0 20 20"
                            >
                                <ImgNotAvailable />
                            </Icon>
                        ) : (
                            ''
                        )}
                    </button>
                </div>
            );
        } else {
            colorItem = this.renderShowMoreLessProductOptions(numOfHiddenSwatches);
        }
        return colorItem;
    }

    showMoreSizeDetails = () => {
        this.setState({ displaySize: !this.state.displaySize });
    };

    showKALink(productDetails) {
        return (
            <KnowledgeAssistance
                automationId="product-option-KnowledgeAssistance"
                aria-label="knowledgeAssistants"
                productDetails={productDetails}
                placement="top"
                templateType="bundle"
            />
        );
    }

    renderShowMoreLessProductOptions(numOfHiddenSwatches) {
        return (
            <button
                className={` ${cx('showMoreLess')} ${dt([
                    'smOnly:!w-[52px]',
                    'smOnly:!h-[52px]',
                    'mdOnly:!w-12',
                    'mdOnly:!h-12',
                    'lg:!w-12',
                    'lg:!h-12',
                    '!rounded-full',
                ])} `}
                onClick={this.showMoreLessOnClick}
            >
                <span>{`${!this.state.viewMoreSwatches ? '+' : '-'}${numOfHiddenSwatches}`}</span>
            </button>
        );
    }

    /* ProductOptions Color UI */
    renderProductOptionsColor(dimension) {
        const {
            featureFlags: { enableHandleColorizedImage = true, enableColorCarousel = true },
            deviceType: { isMobile },
        } = this.props;
        let datasource = [];
        const shouldRenderMoreOrLess = !(enableColorCarousel && isMobile);
        dimension.options =
            dimension.options &&
            dimension.options.length &&
            dimension.options.length > 1 &&
            enableHandleColorizedImage
                ? dimension.options.filter(({ productImage }) => productImage)
                : dimension.options;
        if (
            dimension.options &&
            dimension.options.length > swatchesMaxLn + 1 &&
            shouldRenderMoreOrLess
        ) {
            datasource = [
                ...dimension.options,
                { family: 'More or Less Option', value: 'more or less Option' },
            ];
            this.displayMoreOrLess = true;
        } else {
            datasource = dimension.options;
        }
        const mobileColorCaraouselStyle = enableColorCarousel
            ? dt([
                  'flex',
                  'flex-nowrap',
                  'overflow-y-scroll',
                  'scroll-smooth',
                  'smOnly:-mx-6',
                  'smOnly:w-[calc(100%+48px)]',
                  'smOnly:pl-6',
              ])
            : '';
        return (
            <div
                className={cx('selectList')}
                onMouseLeave={
                    this.props.deviceType.isDesktop &&
                    dimension.name === 'color' &&
                    this.onColorSwatchLeave.bind(this)
                }
            >
                <List
                    {...this.props}
                    childRenderer={this.renderProductOptionsColorItem.bind(this, dimension)} // eslint-disable-line
                    direction="Fluid"
                    automationId={`product-dimensions-${dimension.name}`}
                    datasource={datasource}
                    spacing="None"
                    itemSpacing="None"
                    listStyleClass={`${cx('noScrollBar')} ${isMobile && mobileColorCaraouselStyle}`}
                    id="productOptionsColorList"
                />
            </div>
        );
    }

    renderErrorMessage(dimensionId, productDetailsId) {
        const { messages } = this.props;
        let errorMsg = null;
        /* istanbul ignore next */
        if (
            messages[`${dimensionId}_MESSAGES_SECTION_${productDetailsId}`] &&
            messages[`${dimensionId}_MESSAGES_SECTION_${productDetailsId}`].length > 0
        ) {
            errorMsg = (
                <div className={cx('errorMessage')}>
                    <Messages
                        level={messagesLevels.inline}
                        messages={messages[`${dimensionId}_MESSAGES_SECTION_${productDetailsId}`]}
                        hasClose={false}
                    />
                </div>
            );
        }
        return errorMsg;
    }

    renderSecondaryDimension(dimension, option, productDetailsId) {
        const oosSelectedColorName = option.split('-');
        const errorMessage = this.renderErrorMessage(dimension.id, productDetailsId);
        let messageBlock = null;

        const oosMessageBlock = oosSelectedColorName[1] && (
            <>
                <span> - </span>
                <span className={cx('oosMessage text-urgency')}>{oosSelectedColorName[1]}</span>
            </>
        );

        /* istanbul ignore next */
        if (dimension.id === 'COLOR' && option) {
            messageBlock = (
                <div
                    className={cx('secondaryDimensionSpan')}
                    aria-label={option.toLowerCase()}
                    data-automation-id={option.toLowerCase()}
                >
                    <span>
                        <span
                            className={dt(['font-sans', 'font-semibold', 'text-sm', 'text-black'])}
                        >
                            Color
                        </span>
                        {oosMessageBlock ? (
                            <>
                                <span>{` - `}</span>
                                <span className={dt(['line-through', 'text-sm'])}>
                                    {oosSelectedColorName[0]}
                                </span>
                            </>
                        ) : (
                            <span
                                className={dt(['text-sm'])}
                            >{` - ${oosSelectedColorName[0].toLowerCase()}`}</span>
                        )}
                    </span>
                </div>
            );
        } else if (dimension.id === 'COLOR') {
            messageBlock = errorMessage || (
                <>
                    <span className={dt(['font-opensans-semibold', 'text-black'])}>Color</span>
                    <span className={cx('oosMessage')}>{` - ${DEFAULT_COLOR_MSG}`}</span>
                </>
            );
        }
        return messageBlock;
    }

    /* This is the container UI that has label, options (both dropdown UIs and color UI) and then the grid info. */
    renderProductOptionsContainer(dimensionsData) {
        const {
            productDetails,
            productOptions: { optionsSelected },
            productPillsLimit,
            featureFlags,
        } = this.props;
        const { hoveredSwatch } = this.state;
        let productOptionsList = '';
        let showHidelotFlag = '';
        const defaultValueRequired = true;
        let kaLink = null;
        let bvTrueToFit = '';
        const { enableColorSwatchOnTop = true } = featureFlags;
        const dimensions = enableColorSwatchOnTop
            ? this.replaceColorInDimensions(dimensionsData)
            : [...dimensionsData];
        let selectedColorName = '';
        const showOptionsClassName = dt([
            'block',
            'font-sans',
            'font-semibold',
            'text-sm',
            'leading-6',
            'text-black',
        ]);
        return dimensions.map((dimension) => {
            showHidelotFlag =
                dimension.type === 'lot' && ProductModule.getShowHidelotFlag(productType)
                    ? 'hideOptions'
                    : showOptionsClassName;
            const dimensionWithUnavailableFiltersRemoved = ProductModule.removeUnavailableFilters(
                dimension
            );
            if (dimension.id === 'COLOR') {
                if (hoveredSwatch) {
                    selectedColorName = hoveredSwatch.availabilityMessage;
                }
                if (!selectedColorName) {
                    const [{ option = '' } = {}] = filter(
                        optionsSelected,
                        ({ type }) => type === 'COLOR'
                    );
                    if (
                        get(find(dimension.options, { value: option }), 'availabilityMessage', '')
                    ) {
                        selectedColorName = get(
                            find(dimension.options, { value: option }),
                            'availabilityMessage',
                            ''
                        );
                    }
                }
                productOptionsList = this.renderProductOptionsColor(
                    dimensionWithUnavailableFiltersRemoved
                );
            } else {
                // if the filters are selected then availabilityMessage is set for each option object. If filters are not
                // selected then availabilityMessage is undefined.
                const value = this.getDefaultValueSelected(
                    dimensionWithUnavailableFiltersRemoved.id
                );
                productOptionsList =
                    get(dimensionWithUnavailableFiltersRemoved, 'options.length') <=
                    productPillsLimit ? (
                        <ProductOptionPills
                            productOptions={dimensionWithUnavailableFiltersRemoved}
                            onOptionClick={this.onChangeHandler.bind(this)} // eslint-disable-line
                            selectedOption={value}
                            clientRendering
                        />
                    ) : (
                        <div>
                            <SelectDropdown
                                name={dimensionWithUnavailableFiltersRemoved.name}
                                automationId={`product-dimensions-${dimensionWithUnavailableFiltersRemoved.name}`}
                                datasource={dimensionWithUnavailableFiltersRemoved.options}
                                defaultValueRequired={defaultValueRequired}
                                optionDisplayValue="availabilityMessage"
                                optionValue="value"
                                selectStyle={showHidelotFlag}
                                theme={dt(['lg:w-3/5'])}
                                onChangeHandler={this.onChangeHandler.bind(
                                    // eslint-disable-line
                                    this,
                                    dimensionWithUnavailableFiltersRemoved,
                                    null
                                )}
                                value={value}
                                regularItem
                            />
                        </div>
                    );
            }
            if (this.isSizeDimension(dimension)) {
                kaLink = (
                    <div
                        className={cx('col6', 'knowledgeAssistanceBlock')}
                        aria-label="KnowledgeAssistance"
                    >
                        {this.state.displayTopSizeChart && this.showKALink(productDetails)}
                    </div>
                );
                bvTrueToFit = (
                    <div className={cx('dimensionName', 'row', 'bvTrueToFitBlock')}>
                        <div aria-label="bvTrueToFit">
                            <div id="BVSecondarySummaryContainer" />
                        </div>
                    </div>
                );
            } else {
                kaLink = null;
            }
            return (
                <div className={`${cx('wrapper')} ${dt(['mb-2'])}`} key={dimension.id}>
                    <div className={cx('dimensionName', 'row', showHidelotFlag)}>
                        {/* Take col12 space if kaLink is not there */}
                        {dimension.id !== 'COLOR' && (
                            <div className={cx('errorMessage')}>
                                <Messages
                                    level={messagesLevels.inline}
                                    messages={
                                        this.props.messages[
                                            `${dimension.id}_MESSAGES_SECTION_${productDetails.id}`
                                        ]
                                    }
                                    hasClose={false}
                                />
                            </div>
                        )}
                        <div className={cx('dimensionNameBlock', kaLink ? 'col6' : 'col12')}>
                            <span aria-label={dimension.name} data-automation-id={dimension.name}>
                                {dimension.name !== 'color' && dimension.name}
                            </span>
                            {this.renderSecondaryDimension(
                                dimension,
                                selectedColorName,
                                productDetails.id
                            )}
                        </div>
                        {kaLink}
                    </div>
                    {productOptionsList}
                    {bvTrueToFit}
                </div>
            );
        });
    }

    render() {
        const {
            productOptions,
            featureFlags: { disableDataSizeChart = false },
            productDetails,
            getBundleInventory,
        } = this.props;
        const { optionsSelected = [] } = productOptions;
        const itemOfferingCall = get(productOptions, 'pricingURL.itemOfferingCall', false);
        let itemNotInStock = true;
        if (itemOfferingCall) {
            itemNotInStock = !get(
                getBundleInventory,
                `inventoryStatus.${productDetails.id}.isInventoryAvailable`,
                true
            );
        } else {
            itemNotInStock = !productOptions.isProductInStock || !productOptions.isItemInStock;
        }
        const selectedSKU = get(productOptions, 'pricingURL.selectedSKU', '');
        const { displaySize } = this.state;
        return (
            <>
                <section className={cx('optionContainer')}>
                    {productOptions.dimensions && (
                        <div>
                            {itemNotInStock && (
                                <div className={dt(['mb-2'])}>
                                    <Icon
                                        className={dt(['text-urgency-border'])}
                                        iconType="svg"
                                        width="24px"
                                        height="24px"
                                        viewBox="0 2 40 40"
                                    >
                                        <Warning />
                                    </Icon>
                                    <span className={cx('oosMessage')}>
                                        This Item is Out of Stock
                                    </span>
                                </div>
                            )}
                            {productOptions.dimensions.length > 0 &&
                                this.renderProductOptionsContainer(productOptions.dimensions)}
                        </div>
                    )}
                </section>
                <section>
                    {!disableDataSizeChart && this.state.displayTopSizeChart && (
                        <DataSizeChart
                            displaySize={displaySize}
                            showKALink={this.showKALink}
                            productDetails={productDetails}
                            showMoreSizeDetails={this.showMoreSizeDetails}
                            optionsSelected={optionsSelected}
                            disableDataSizeChart={disableDataSizeChart}
                            selectedSKUId={selectedSKU}
                        />
                    )}
                </section>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    inventory: state.inventory,
    deviceType: state.context ? state.context.deviceType : {},
    messagesTexts: state.context.messagesTexts,
    changeOption: state.productOptions,
    storeID: getStoreID(state),
    deviceName: selectDeviceName(state),
    bundleQuantity: state.bundleQuantity,
    isEveryDimensionSelected: getProductOptionsSelection(state).isEveryDimensionSelected,
    featureFlags: selectFeatureFlags(state),
    productPillsLimit: get(state, 'context.preferences.apollo.productPillsLimit', 9),
    bundleProductOptionsSelectedOnLoad: state.bundleProductOptionsSelectedOnLoad,
    getBundleInventory: getBundleInventoryStatus(state),
});

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(
        {
            ...MessagesActions,
            bundleColorSwatchHover,
            getItemOfferingAction,
            /* Analytics Actions */
            formErrorAnalytics,
            /* Product Options Actions */
            productOptionsBundleOnChangeAction,
            productOptionsBundleOnLoadAction,
        },
        dispatch
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductOptions);
